// removed by extract-text-webpack-plugin
module.exports = {"RightPanelModal":"RightPanelModal__RightPanelModal__-hash-base-64-5-","Buttons":"RightPanelModal__Buttons__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/RightPanelModal/RightPanelModal.scss
// module id = 186
// module chunks = 0